import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersWeeklyReportsFeedbackAnalysisIndexResponseType,
  ApiManagersWeeklyReportsFeedbackAnalysisIndexRequestType,
} from "~/domains";

type RequestDataType = {
  params?: ApiManagersWeeklyReportsFeedbackAnalysisIndexRequestType;
};

const request = async ({
  params,
}: RequestDataType): Promise<ApiManagersWeeklyReportsFeedbackAnalysisIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiManagersWeeklyReportsFeedbackAnalysisIndexResponseType>(
      "/api/managers/weekly_reports/feedback_analysis",
      params,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiManagersWeeklyReportsFeedbackAnalysisIndexRequestType;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisManagersWeeklyReportsFeedbackAnalysisIndex = ({
  params,
  config = {},
}: PropsType = {}): UseQueryResult<ApiManagersWeeklyReportsFeedbackAnalysisIndexResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisManagersWeeklyReportsFeedbackAnalysisIndex", params],
    queryFn: () => request({ params }),
  });
};
